import { c as _c } from "react/compiler-runtime";
import { ModalTypeEnum, useModal } from "@/components/providers/modal-provider/ModalProvider";
import { useCallback } from "react";
import { UserConversationChat } from "../components/UserConversationChat/UserConversationChat";
import { SearchUserSchemaType } from "../../user/api/schemas";
import { useQueryClient } from "@tanstack/react-query";
import { USER_CONVERSATION_BYID__QUERY_KEYS } from "../api/queries/useConversationById";
import { useIsMobile } from "@/hooks/use-mobile";
import { RealEstateConversationAtributesSchemaType } from "../api/schemas";
import { CONVERSATION_MODAL_ID, setConversationParam } from "./conversationDeepLink";
export function useConversation() {
  const $ = _c(8);
  const {
    openModal
  } = useModal();
  const queryClient = useQueryClient();
  const isMobile = useIsMobile();
  let t0;
  if ($[0] !== queryClient) {
    t0 = t1 => {
      const {
        conversationId
      } = t1;
      setConversationParam(null);
      queryClient.setQueryData(USER_CONVERSATION_BYID__QUERY_KEYS.getConversationById(conversationId), _temp2);
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleCloseConversation = t0;
  let t1;
  if ($[2] !== handleCloseConversation || $[3] !== isMobile || $[4] !== openModal) {
    t1 = t2 => {
      const {
        conversationId: conversationId_0,
        recipientId,
        user,
        realEstateId,
        realEstateConversationAtributes,
        isFriend
      } = t2;
      if (conversationId_0) {
        setConversationParam(conversationId_0);
      }
      if (isMobile) {
        openModal(ModalTypeEnum.GENERIC_SHEET, {
          onClose: () => handleCloseConversation({
            conversationId: conversationId_0
          }),
          children: <UserConversationChat conversationId={conversationId_0} recipientId={recipientId} user={user} realEstateId={realEstateId} realEstateConversationAtributes={realEstateConversationAtributes} isFriend={isFriend} />,
          className: "w-full"
        }, CONVERSATION_MODAL_ID);
        return;
      }
      if (!isMobile) {
        openModal(ModalTypeEnum.GENERIC_DIALOG, {
          onClose: () => handleCloseConversation({
            conversationId: conversationId_0
          }),
          children: <UserConversationChat conversationId={conversationId_0} recipientId={recipientId} user={user} realEstateId={realEstateId} realEstateConversationAtributes={realEstateConversationAtributes} isFriend={isFriend} />
        }, CONVERSATION_MODAL_ID);
        return;
      }
    };
    $[2] = handleCloseConversation;
    $[3] = isMobile;
    $[4] = openModal;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOpenConversation = t1;
  let t2;
  if ($[6] !== handleOpenConversation) {
    t2 = {
      handleOpenConversation
    };
    $[6] = handleOpenConversation;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp2(oldData) {
  if (!oldData) {
    return oldData;
  }
  const firstPage = oldData.pages?.[0];
  if (!firstPage) {
    return oldData;
  }
  return {
    ...oldData,
    pages: oldData.pages.map(_temp)
  };
}
function _temp(page, index) {
  if (index === 0) {
    return {
      ...page,
      data: {
        ...page.data,
        conversation: {
          ...page.data.conversation,
          lastMessageReadAt: new Date().toISOString(),
          unreadCount: 0
        }
      }
    };
  }
  return page;
}